/**
 * Capitalizes the first letter of each whitespace-separated word.
 */
export const capitalizeWords = (value: string): string => {
	if (!value) {
		return value;
	}

	return value.replaceAll(/(?<=^|\s)\S/g, char => char.toUpperCase());
};
